import { StandardEvents } from '@shopify/events';

const promotionUpdateEvent = 'supra:volume-promotion:update';

function tierFor(quantity) {
  if (quantity >= 5) return { discount: 25 };
  if (quantity === 4) return { discount: 20 };
  if (quantity === 3) return { discount: 15 };
  if (quantity === 2) return { discount: 10 };
  return { discount: 0 };
}

function updateProgress(state) {
  const tier = tierFor(state.eligibleQuantity);
  const noun = state.eligibleQuantity === 1 ? 'fragancia elegible' : 'fragancias elegibles';
  let benefitText = 'Agrega 2 perfumes elegibles para obtener 10% de descuento y envío gratis.';
  if (state.eligibleQuantity === 1) {
    benefitText = 'Agrega 1 perfume más para obtener 10% de descuento y envío gratis.';
  } else if (state.eligibleQuantity >= 2) {
    benefitText = `Beneficio estimado: ${tier.discount}% de descuento y envío gratis.`;
  }

  for (const progress of document.querySelectorAll('supra-volume-progress')) {
    const summary = progress.querySelector('[data-supra-promotion="summary"]');
    const tierLabel = progress.querySelector('[data-supra-promotion="tier"]');
    const next = progress.querySelector('[data-supra-promotion="next"]');

    if (summary) summary.textContent = `${state.eligibleQuantity} ${noun} en el carrito`;
    if (tierLabel) tierLabel.textContent = tier.discount > 0 ? `${tier.discount}% estimado` : 'Precio regular';
    if (next) next.textContent = benefitText;
  }
}

class SupraVolumePromotionState extends HTMLElement {
  controller = new AbortController();
  refreshPromise = null;

  connectedCallback() {
    const { signal } = this.controller;
    document.addEventListener(StandardEvents.cartLinesUpdate, this.handleCartEvent, { signal });
    document.addEventListener(StandardEvents.cartDiscountUpdate, this.handleCartEvent, { signal });
    document.addEventListener(StandardEvents.cartView, this.handleCartEvent, { signal });
    this.publish();
  }

  disconnectedCallback() {
    this.controller.abort();
  }

  get state() {
    return {
      eligibleQuantity: Number(this.dataset.eligibleQuantity) || 0,
      eligibleOriginalSubtotal: Number(this.dataset.eligibleOriginalSubtotal) || 0,
      eligibleFinalSubtotal: Number(this.dataset.eligibleFinalSubtotal) || 0,
      cartItemCount: Number(this.dataset.cartItemCount) || 0,
      cartOriginalTotal: Number(this.dataset.cartOriginalTotal) || 0,
      cartTotal: Number(this.dataset.cartTotal) || 0,
      cartTotalDiscount: Number(this.dataset.cartTotalDiscount) || 0,
      currency: this.dataset.currency || 'MXN',
      locale: this.dataset.locale || 'es-MX',
    };
  }

  handleCartEvent = (event) => {
    const completion = event.promise;
    if (completion && typeof completion.then === 'function') {
      completion.then(this.refresh).catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[supra-volume-promotion]', error);
      });
      return;
    }

    this.refresh().catch(() => {});
  };

  refresh = () => {
    if (this.refreshPromise) return this.refreshPromise;

    this.refreshPromise = fetch(this.dataset.stateUrl, {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
      cache: 'no-store',
    })
      .then((response) => {
        if (!response.ok) throw new Error(`No se pudo actualizar la promoción: ${response.status}`);
        return response.json();
      })
      .then((sections) => {
        const html = sections['supra-volume-promotion-state'];
        if (!html) throw new Error('Shopify no devolvió el estado de la promoción.');

        const documentFragment = new DOMParser().parseFromString(html, 'text/html');
        const nextState = documentFragment.querySelector('supra-volume-promotion-state');
        if (!nextState) throw new Error('El estado renderizado de la promoción es inválido.');

        for (const [key, value] of Object.entries(nextState.dataset)) {
          this.dataset[key] = value;
        }

        this.publish();
        return this.state;
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[supra-volume-promotion]', error);
        throw error;
      })
      .finally(() => {
        this.refreshPromise = null;
      });

    return this.refreshPromise;
  };

  publish() {
    const state = this.state;
    updateProgress(state);
    document.dispatchEvent(new CustomEvent(promotionUpdateEvent, { detail: state }));
  }
}

if (!customElements.get('supra-volume-promotion-state')) {
  customElements.define('supra-volume-promotion-state', SupraVolumePromotionState);
}
